export default __webpack_public_path__ + "static/media/encappture-icon.655fa90c.svg";